export interface ValidationResult {
  valid: boolean;
  reason: string;
}

export function validateReferralDomains(
  referrerEmail: string,
  referredEmail: string
): ValidationResult {
  const referrerDomain = referrerEmail.split("@")[1];
  const referredDomain = referredEmail.split("@")[1];

  if (referrerDomain === referredDomain) {
    return { valid: false, reason: "Same company domain not allowed" };
  }

  // Check for similar domains (e.g., company.com vs company.ro)
  const referrerBase = referrerDomain.split(".")[0];
  const referredBase = referredDomain.split(".")[0];

  if (referrerBase === referredBase) {
    return { valid: false, reason: "Similar company domain not allowed" };
  }

  return { valid: true, reason: "Valid domain pair" };
}

export function generateReferralCode(): string {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "NIS2PASS-";
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export function createReferralLink(code: string): string {
  return `${window.location.origin}/ref/${code}`;
}

export function createLinkedInShareText(referralLink: string): string {
  return `Am finalizat cu succes raportul de conformitate NIS2 folosind platforma NIS2PASS.ro! 🎯

Dacă și compania ta trebuie să se conformeze cu Directiva NIS2, încearcă platforma gratuită: ${referralLink}

#NIS2 #Cybersecurity #Conformitate #Romania`;
}

export function maskEmail(email: string): string {
  const [username, domain] = email.split("@");
  if (username.length <= 2) {
    return `${username[0]}***@${domain}`;
  }
  return `${username.slice(0, 2)}***@${domain}`;
}
